import { render } from "./HistoryBuyDetail.vue?vue&type=template&id=222942d6"
import script from "./HistoryBuyDetail.vue?vue&type=script&lang=js"
export * from "./HistoryBuyDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__